import './index.css';
import { Routes, Route } from 'react-router-dom';
// import Login from './components/login';
import MainLayout from './components/mainLayout';
import Options from './components/options';
import Dashboard from './components/dashboard';
import OrderOpenPositions from './components/orderopenpositions';
import OrderClosedPositions from './components/orderclosedpositions';
import MITEvents from './components/mitevents';
import ParadigmEvents from './components/paradigmevents';
import Unauthorized from './components/unauthorized';
import Mitmobile from './components/mitmobile';
import OptionGraph from './components/optiongraph';

function App() {
  return (

    <div className="App">
      <Routes>
        {/* <Route path="/" element={<Login />} /> */}
        <Route path="/" element={<MainLayout><MITEvents /> </MainLayout>} />
        {/* <Route path="/events/mit" element={<MainLayout><MITEvents /> </MainLayout>} /> */}
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/dashboard" element={<MainLayout><Dashboard /> </MainLayout>} />
        <Route path="/events/mitmobile" element={<MainLayout><Mitmobile /> </MainLayout>} />
        <Route path="/options" element={<MainLayout><Options /> </MainLayout>} />
        <Route path="/positions/open" element={<MainLayout><OrderOpenPositions /> </MainLayout>} />
        <Route path="/positions/closed" element={<MainLayout><OrderClosedPositions /> </MainLayout>} />
        <Route path="/events/paradigm" element={<MainLayout><ParadigmEvents /> </MainLayout>} />
        <Route path="/options/graph" element={<MainLayout><OptionGraph /> </MainLayout>} />
      </Routes>
    </div>
  );
}

export default App;